<!--begin::Logo-->
<a routerLink="/">
	<img alt="Logo" [attr.src]="headerLogo" />
</a>
<!--end::Logo-->

<!--begin::Toolbar-->
<div class="d-flex align-items-center justify-content-end">
	<ng-container *ngIf="asideSelfDisplay">
		<!--begin::Aside Mobile Toggle-->
		<button class="btn p-0 burger-icon burger-icon-left" id="kt_aside_mobile_toggle">
			<span></span>
		</button>
		<!--end::Aside Mobile Toggle-->
	</ng-container>

	<ng-container *ngIf="headerMenuSelfDisplay">
		<!--begin::Header Menu Mobile Toggle-->
		<button class="btn p-0 burger-icon ml-4" id="kt_header_mobile_toggle"
        (click)="openDropdowm()"
        >
			<span></span>
		</button>
		<!--end::Header Menu Mobile Toggle-->
	</ng-container>


    <ng-container *ngIf="user$ | async as _user">
        <div class="dropdown" ngbDropdown placement="bottom-right">
          <div class="topbar-item" data-toggle="dropdown" data-offset="0px,0px" ngbDropdownToggle>
            <div class="btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2">
              <span class="text-muted font-weight-bold font-size-base d-none d-md-inline mr-2">Hola,</span>
              <span
                class="text-dark-50 font-weight-bolder font-size-base d-md-inline mr-3 d-none">{{ _user.fullname }}</span>
              <span class="symbol symbol-35">
                <span class="symbol-label font-size-h5 font-weight-bold">
                  <span class="symbol-label font-size-h5 font-weight-bold bg-primary-o-30">{{ _user.firstname | firstLetter }}</span>
                </span>
              </span>
            </div>
          </div>
          <!--end::Toggle-->
          <!--begin::Dropdown-->
          <div ngbDropdownMenu
            class="dropdown-menu p-0 m-0 dropdown-menu-right dropdown-menu-anim-up dropdown-menu-lg p-0">
            <div class="navi navi-spacer-x-0 pt-5 myprofile">
                <!--begin::Item-->
                <a class="navi-item px-8 cursor-pointer" routerLink="/myprofile">
                  <div class="navi-link">
                    <div class="navi-icon mr-2">
                      <i class="flaticon2-calendar-3 text-success"></i>
                    </div>
                    <div class="navi-text">
                      <div class="font-weight-bold">
                        Mi Perfil
                      </div>
            
                    </div>
                  </div>
                </a>
            
            
                <a class="navi-item px-8 cursor-pointer" routerLink="/contacts" *ngIf="false">
                  <div class="navi-link">
                    <div class="navi-icon mr-2">
                      <i class="flaticon2-calendar-3 text-success"></i>
                    </div>
                    <div class="navi-text">
                      <div class="font-weight-bold">
                        {{ "GENERAL.CONTACTS" | translate }}
                      </div>
            
                    </div>
                  </div>
                </a>
            
                <a *ngIf="false" class="navi-item px-8 cursor-pointer" href="javascript:void(0)" (click)="onCreateUser(createUserModal)">
                  <div class="navi-link">
                    <div class="navi-icon mr-2">
                      <i class="flaticon2-calendar-3 text-success"></i>
                    </div>
                    <div class="navi-text">
                      <div class="font-weight-bold">
                        {{ "AUTH.GENERAL.USER_CREATE" | translate }}
                      </div>
            
                    </div>
                  </div>
                </a>
                
                <a class="navi-item px-8 cursor-pointer" href="javascript:void(0)" (click)="onChangePassword(content)"  *ngIf="false">
                  <div class="navi-link">
                    <div class="navi-icon mr-2">
                      <i class="flaticon2-calendar-3 text-success"></i>
                    </div>
                    <div class="navi-text">
                      <div class="font-weight-bold">
                        {{ "AUTH.GENERAL.CHANGEPASSWORD" | translate }}
                      </div>
                      
                    </div>
                  </div>
                </a>
            
                <a class="navi-item px-8 cursor-pointer" (click)="logout()">
                  <div class="navi-link">
                    <div class="navi-icon mr-2">
                      <i class="flaticon2-calendar-3 text-success"></i>
                    </div>
                    <div class="navi-text">
                      <div class="font-weight-bold">
                        {{ "AUTH.LOGIN.CLOSE_SESION" | translate }}
                      </div>
                    </div>
                  </div>
                </a>
                <!--end::Item-->
            
                <!--end::Footer-->
              </div>
          </div>
        </div>
        <!--end::Dropdown-->
      </ng-container>

	<!--end::Topbar Mobile Toggle-->
</div>
<!--end::Toolbar-->



<div class="createUserModal">
    <span *ngIf="closeResult">
      <pre>{{closeResult}}</pre>
    </span>
    <div>
  
    <ng-template #createUserModal let-c="close" let-d="dismiss">
        <div class="modal-header">
            <h4 class="modal-title font-weight-bolder">{{ "AUTH.GENERAL.USER_CREATE" | translate }}</h4>
            <button type="button" class="close" aria-label="Close" (click)="d('Close click')">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <form
              class="form fv-plugins-bootstrap fv-plugins-framework"
              novalidate="novalidate"
              [formGroup]="createUserForm"
              (ngSubmit)="submitCreateUser()"
            >
        <div class="modal-body">
            <div class="modal-template-1" *ngIf="modalTemplate == 1">
              <!--begin::Form-->
              
              <!-- begin::Alert error-->
              <ng-container *ngIf="errorState === errorStates.HasError">
                <div class="mb-10 alert alert-custom alert-light-danger alert-dismissible" >
                  <div class="alert-text">{{ "AUTH.GENERAL.CREATE_USER_ERROR" | translate }}</div>
                </div>
              </ng-container>
              <!-- end::Alert error-->
  
              <div class="form-group">
                <label class="sr-only font-size-h6 font-weight-bolder text-dark">{{ "AUTH.GENERAL.CODEPASSWORD" | translate }}</label>
                <input
                  class="form-control form-control-solid  font-size-h6"
                  type="text"
                  name="email"
                  formControlName="email"
                  placeholder="Usuario"
                  autocomplete="off"
                  [ngClass]="{
                    'is-invalid': createUserForm.controls['email'].invalid
                  }"
                />
                <ng-container
                  [ngTemplateOutlet]="formError"
                  [ngTemplateOutletContext]="{
                    validation: 'required',
                    message: 'Campo requerido',
                    control: createUserForm.controls['email']
                  }"
                ></ng-container>
              </div>
  
              <!--begin::Form group-->
              <div class="form-group">
                <label class="sr-only font-size-h6 font-weight-bolder text-dark">{{ "AUTH.REGISTER.PASSWORD" | translate }}</label>
                <input
                  class="form-control form-control-solid  font-size-h6"
                  type="password"
                  placeholder="Contraseña"
                  name="password"
                  formControlName="password"
                  autocomplete="off"
                  [ngClass]="{
                    'is-invalid': createUserForm.controls['password'].invalid
                  }"
                />
                <ng-container
                  [ngTemplateOutlet]="formError"
                  [ngTemplateOutletContext]="{
                    validation: 'required',
                    message: 'Contraseña requerida',
                    control: createUserForm.controls['password']
                  }"
                ></ng-container>
                <ng-container
                  [ngTemplateOutlet]="formError"
                  [ngTemplateOutletContext]="{
                    validation: 'minlength',
                    message: 'La contraseña debe tener al menos 8 caracteres',
                    control: createUserForm.controls['password']
                  }"
                ></ng-container>
              </div>
              <!--end::Form group-->
  
              <!--begin::Form group-->
              <div class="form-group">
                <label class="sr-only font-size-h6 font-weight-bolder text-dark">{{ "AUTH.REGISTER.REPEAT_PASSWORD" | translate }}</label>
                <input
                  class="form-control form-control-solid  font-size-h6"
                  type="password"
                  placeholder="Confirmar contraseña"
                  name="repeatPassword"
                  autocomplete="off"
                  formControlName="repeatPassword"
                  [ngClass]="{
                    'is-invalid': createUserForm.controls['repeatPassword'].invalid
                  }"
                />
                <ng-container
                  [ngTemplateOutlet]="formError"
                  [ngTemplateOutletContext]="{
                    validation: 'required',
                    message: 'Confirmación requerida',
                    control: createUserForm.controls['repeatPassword']
                  }"
                ></ng-container>
                <ng-container
                  *ngIf="
                    createUserForm.controls['repeatPassword'].errors &&
                    createUserForm.controls['repeatPassword'].errors.ConfirmPassword
                  "
                >
                  <div class="fv-plugins-message-container">
                    <div class="fv-help-block">
                      La contraseña no coinciden
                    </div>
                  </div>
                </ng-container>
                
              </div>
            </div>
  
            <div class="modal-template-2" *ngIf="modalTemplate == 2">
              <div class="alert alert-success">
                <p class="font-weight-bold font-size-h4 text-center">
                  {{ "AUTH.GENERAL.SUCCESS_USER_CREATE" | translate }}
                </p>
              </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="submit" [hidden]="errorState==errorStates.UserCreated" class="btn btn-success font-weight-bolder font-size-h6  my-3 mr-4" >
                {{ "INPUT.SUBMIT" | translate }}
            </button>
            <button type="button" class="btn btn-default text-dark" (click)="c('Close click')">{{ "INPUT.CLOSE" | translate }}</button>
        </div>
      </form>
  
    </ng-template>
  </div>
  
  
  <div class="changeUserPassword">
  
    <span *ngIf="closeResult">
      <pre>{{closeResult}}</pre>
    </span>
    <div>
    <ng-template #content let-c="close" let-d="dismiss">
        <div class="modal-header">
            <h4 class="modal-title font-weight-bolder">{{ "AUTH.GENERAL.CHANGEPASSWORD" | translate }}</h4>
            <button type="button" class="close" aria-label="Close" (click)="d('Close click')">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="modal-template-1" *ngIf="modalTemplate == 1">
              <div class="d-flex align-items-center text-center">
                <button class="btn btn-primary" (click)="submitRequestCode(1)">{{ "AUTH.CODEPASSWORD.REQUESTCHANGEPASSWORD" | translate }}</button>
              </div>
            </div>
  
            <div class="modal-template-2" *ngIf="modalTemplate == 2">
              <!--begin::Form-->
              <form
              class="form fv-plugins-bootstrap fv-plugins-framework"
              novalidate="novalidate"
              [formGroup]="changePasswordForm"
              (ngSubmit)="submitChangePassword(2)"
              id="kt_new_password_form"
            >
              <!--begin::Title-->
              <div class=" pt-lg-0 pt-5">
                <p class="font-weight-bold font-size-h4">
                  {{ "AUTH.CODEPASSWORD.FORGOTTEN_PASSWORD_HELP" | translate }}
                </p>
              </div>
              <!--end::Title-->
  
              <!-- begin::Alert error-->
              <ng-container *ngIf="errorState === errorStates.CodeError">
                <div class="mb-10 alert alert-custom alert-light-danger alert-dismissible" >
                  <div class="alert-text">{{ "AUTH.CODEPASSWORD.CODE_PASSWORD_ERROR" | translate }}</div>
                </div>
              </ng-container>
              <!-- end::Alert error-->
  
              <div class="form-group">
                <label class="sr-only font-size-h6 font-weight-bolder text-dark">{{ "AUTH.GENERAL.CODEPASSWORD" | translate }}</label>
                <input
                  class="form-control form-control-solid  font-size-h6"
                  type="text"
                  name="code"
                  formControlName="code"
                  placeholder="Código"
                  autocomplete="off"
                  style="background-color:gainsboro ;"
                  [ngClass]="{
                    'is-invalid': changePasswordForm.controls['code'].invalid
                  }"
                />
                <ng-container
                  [ngTemplateOutlet]="formError"
                  [ngTemplateOutletContext]="{
                    validation: 'required',
                    message: 'Campo requerido',
                    control: changePasswordForm.controls['code']
                  }"
                ></ng-container>
              </div>
  
              <!--begin::Form group-->
              <div class="form-group">
                <label class="sr-only font-size-h6 font-weight-bolder text-dark">{{ "AUTH.REGISTER.PASSWORD" | translate }}</label>
                <input
                  class="form-control form-control-solid  font-size-h6"
                  type="password"
                  placeholder="Contraseña"
                  name="password"
                  formControlName="password"
                  autocomplete="off"
                  [ngClass]="{
                    'is-invalid': changePasswordForm.controls['password'].invalid
                  }"
                />
                <ng-container
                  [ngTemplateOutlet]="formError"
                  [ngTemplateOutletContext]="{
                    validation: 'required',
                    message: 'Contraseña requerida',
                    control: changePasswordForm.controls['password']
                  }"
                ></ng-container>
                <ng-container
                  [ngTemplateOutlet]="formError"
                  [ngTemplateOutletContext]="{
                    validation: 'minlength',
                    message: 'La contraseña debe tener al menos 8 caracteres',
                    control: changePasswordForm.controls['password']
                  }"
                ></ng-container>
              </div>
              <!--end::Form group-->
  
              <!--begin::Form group-->
              <div class="form-group">
                <label class="sr-only font-size-h6 font-weight-bolder text-dark">{{ "AUTH.REGISTER.REPEAT_PASSWORD" | translate }}</label>
                <input
                  class="form-control form-control-solid  font-size-h6"
                  type="password"
                  placeholder="Confirmar contraseña"
                  name="repeatPassword"
                  autocomplete="off"
                  formControlName="repeatPassword"
                  [ngClass]="{
                    'is-invalid': changePasswordForm.controls['repeatPassword'].invalid
                  }"
                />
                <ng-container
                  [ngTemplateOutlet]="formError"
                  [ngTemplateOutletContext]="{
                    validation: 'required',
                    message: 'Confirmación requerida',
                    control: changePasswordForm.controls['repeatPassword']
                  }"
                ></ng-container>
                <ng-container
                  *ngIf="
                    changePasswordForm.controls['repeatPassword'].errors &&
                    changePasswordForm.controls['repeatPassword'].errors.ConfirmPassword
                  "
                >
                  <div class="fv-plugins-message-container">
                    <div class="fv-help-block">
                      La contraseña no coinciden
                    </div>
                  </div>
                </ng-container>
                
              </div>
  
              <!--begin::Form group-->
              <div class="form-group d-flex flex-wrap pb-lg-0">
                <button
                  type="submit"
                  id="kt_change_password_submit"
                  class="btn btn-success font-weight-bolder font-size-h6  my-3 mr-4"
                >
                {{ "INPUT.CHANGE" | translate }}
                </button>
  
                <ng-container *ngIf="isLoading$ | async">
                  <span class="spinner spinner-primary ml-5"></span>
                </ng-container>
              </div>
              <!--end::Form group-->
            </form>
            </div>
  
            <div class="modal-template-3" *ngIf="modalTemplate == 3">
              <!--begin::Title-->
              <div class="alert alert-success">
                <p class="font-weight-bold font-size-h4 text-center">
                  {{ "AUTH.CODEPASSWORD.SUCCESS" | translate }}
                </p>
              </div>
              <!--end::Title-->
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-default text-dark" (click)="c('Close click')">Cerrar</button>
        </div>
    </ng-template>
  </div>
  
  <ng-template
    #formError
    let-control="control"
    let-message="message"
    let-validation="validation"
  >
    <ng-container
      *ngIf="control.hasError(validation) && (control.dirty || control.touched)"
    >
      <div class="fv-plugins-message-container">
        <div class="fv-help-block">
          {{ message }}
        </div>
      </div>
    </ng-container>
  </ng-template>
  